import { BaseValidationDefinition, RangeValidationDefinition, ValidationDefinition } from '@msdk/definitions'

import { processCondition } from './process-condition'

export function getExpressionForValidation(v: BaseValidationDefinition, row?: boolean): string {
  let expression = ''

  switch (v.validationType) {
    case 'RemoveOption':
    case 'KeepOption':
    case 'Expression':
      expression = processCondition((v as ValidationDefinition).condition)
      break
    case 'Mandatory':
      expression = `${row ? 'row' : 'entity'}.IsEmpty('${v.field}')`
      break
    case 'Range':
      // eslint-disable-next-line no-case-declarations
      const r = v as RangeValidationDefinition
      expression = getRangeExpression(r.min, r.max, r.field, row)
      break
    case 'Suggested':
    case 'Invisible':
    case 'Step':
    case 'Readonly':
      break
    default:
      throw new Error('Unsupported validation type: ' + v.validationType)
  }
  return expression
}

export function getRangeExpression(min: number, max: number, fieldName: string, row?: boolean) {
  let expression = ''

  const notEmpty = `!${row ? 'row' : 'entity'}.IsEmpty('${fieldName}')`
  const checkAccessor = `${row ? 'row' : 'entity'}.CheckRange('${fieldName}', ${min}, ${max})`

  expression = `${notEmpty} && ${checkAccessor}`
  return expression
}
